
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const statusPaid = computed(() => {
      const isLogged = store.getters["user/isLogged"];
      if (isLogged) return !store.getters["user/isPaid"];
      return false;
    });
    const logout = async () => {
      await store.dispatch("user/signOut");
    };
    const goToCheckout = () => {
      router.push({
        name: "Checkout",
        params: { eventID: eventData.value.id },
      });
    };
    return {
      statusPaid,
      logout,
      goToCheckout,
    };
  },
};
